import { ManagePersonalAccessTokens } from "../../components/ManagePersonalAccessTokens";

export const PersonalAccessTokensApp = () => {
  return <ManagePersonalAccessTokens />;
};
